import { Box, Stack, Typography } from "@mui/material";
import CloseIconButton from "src/components/CloseIconButton";
import InstructionsIcon from "src/assets/icon_instructions.svg";

export const InstructionBox = ({
  title,
  handler,
  description
}: any) => {
  return (
    <Box 
      display='grid'
      gridTemplateColumns='0.4fr 10fr 0.3fr'
      sx={{ m: 2, py: 2, backgroundColor: '#cafdf5', borderRadius: 1 }} 
    >
      <InstructionsIcon style={{ justifySelf: 'center' }}/>
      <Stack direction="column">
        <Typography variant="button">{title}</Typography>
        <Typography variant="body2">{description}</Typography>
      </Stack>
      <CloseIconButton 
        size="small" 
        sx={{ position: 'absolute', right: '25px' }}  
        onClick={handler}
      />
    </Box>
  )
};